const styles = theme => ({
  tagContainer: {
    display: "flex",
    paddingBottom: "2%",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },

  tagStyles: {
    letterSpacing: 0,
    color: theme.palette.primary.main,
    paddingRight: theme.spacing(1)
  },
  noPostsContainer: {
    marginTop: theme.spacing(2)
  },
  textPosts: {
    color: theme.palette.primary.default,
    marginTop: theme.spacing(6)
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Posts/styles.js